import { compact } from 'lodash';
import React, { useState } from 'react';
import { Platform, Text, TouchableHighlight, View } from 'react-native';
import { Menu } from 'react-native-paper';
import ImageIcon from '../../../../components/shared/Icon/ImageIcon.component';
import colors from '../../../../config/colors';
import useDevicePlatform, {
	DeviceType,
} from '../../../../hooks/useDevicePlatform.hook';
import { i18nService } from '../../../../services/i18n.service';
import {
	deleteDocumentApiModal,
	ScreenSendDocumentsToEmployeeModal,
	sendReminderToEmployee,
} from '../../../Documents/Documents.utils';
import I18n from '../../../../components/shared/i18n/I18n.component';
const ActionButtonsMenu = ({
	userId,
	name,
	unitId,
	docId,
	showSendReminder,
	showDelete,
	setRemoveDoc,
	customStayle,
	setShowModal,
	rowData,
	onUpdateUser,
	onOpenInviteHistory,
}: any) => {
	const [isSelectedButtonsMenuOpen, setIsSelectedButtonsMenuOpen] =
		useState<boolean>(false);
	const [id, setId] = useState<number | null>(null);
	const platform = useDevicePlatform();
	const actionsButton = compact([
		{
			title: 'usersManagement.modal.documents.integration.menu.sendNewDoc',
			icon: 'clipboardText',
			onPress: () => {
				platform !== DeviceType.WEB
					? setShowModal({ id: userId, name, unitId })
					: ScreenSendDocumentsToEmployeeModal(userId, name, unitId);
			},
		},
		{
			title: 'usersManagement.modal.documents.integration.menu.updateUser',
			icon: 'editPencil',
			onPress: () => {
				onUpdateUser?.(rowData);
			},
		},
		// showSendReminder && {
		// 	title: 'usersManagement.modal.documents.integration.menu.sendReminder',
		// 	onPress: () => {
		// 		sendReminderToEmployee(id);
		// 	},
		// },
		showDelete && {
			title: 'usersManagement.modal.documents.integration.menu.delete',
			//icon: 'trash',
			onPress: () => {
				deleteDocumentApiModal(docId, setRemoveDoc);
			},
		},
		// only the web table supplies a handler - the item stays hidden on mobile
		onOpenInviteHistory && {
			title: 'usersManagement.modal.documents.integration.menu.inviteHistory',
			icon: 'history',
			onPress: () => {
				onOpenInviteHistory(rowData);
			},
		},
	]);

	return (
		<Menu
			visible={isSelectedButtonsMenuOpen}
			contentStyle={{
				marginTop: Platform.OS === 'web' ? 40 : -20,
				marginLeft: 5,
				backgroundColor: colors.white,
				width: 220,
				borderRadius: 8,
				...Platform.select({
					web: { boxShadow: '2px 4px 4px 0px rgba(124, 124, 124, 0.16)' } as any,
				}),
			}}
			onDismiss={() => setIsSelectedButtonsMenuOpen(false)}
			anchor={
				<TouchableHighlight
					underlayColor='transparent'
					onPress={() => {
						setIsSelectedButtonsMenuOpen(
							!isSelectedButtonsMenuOpen,
						);
						setId(userId);
					}}
				>
					<View
						style={{
							marginHorizontal: Platform.OS === 'web' ? 10 : 0,
							paddingHorizontal: Platform.OS === 'web' ? 10 : 0,
							alignItems: 'center',
							paddingVertical: 6,
							...customStayle,
						}}
					>
						<ImageIcon
							width={4}
							height={22}
							name={'verticalDots'}
						/>
					</View>
				</TouchableHighlight>
			}
		>
			{actionsButton.map(
				(
					action: {
						title: string;
						icon: string;
						onPress?: Function;
					},
					index: number,
				) => (
					<Menu.Item
						key={index}
						onPress={() => {
							action.onPress?.();
							setIsSelectedButtonsMenuOpen(false);
						}}
						style={{
							alignItems: 'flex-end',
							borderBottomWidth: index < actionsButton.length - 1 ? 1 : 0,
							borderBottomColor: colors.greySeparator,
							...Platform.select({
								web: {
									cursor: 'pointer',
								},
							}),
						}}
						titleStyle={{
							color: colors.primaryDarkBlue,
							textAlign: 'right',
						}}
						title={
							<View
								style={{
									flexDirection:
										Platform.OS === 'ios' ? 'row-reverse' : 'row',
									alignItems: 'center',
								}}
							>
								<ImageIcon
									width={18}
									height={18}
									name={action.icon as any}
									style={
											{ marginLeft: 8 }
									}
								/>
								<I18n size={14} color='primaryDarkBlue'>
									{i18nService.translate(action.title)}
								</I18n>
							</View>
						}
					/>
				),
			)}
		</Menu>
	);
};

export default ActionButtonsMenu;
